/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownWithdrawalReason } from '../models/db_DropdownWithdrawalReason';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WithdrawalReasons {
    /**
     * Get a list of withdrawal reasons
     * @returns db_DropdownWithdrawalReason OK
     * @throws ApiError
     */
    public static listWithdrawalReasons(): CancelablePromise<Array<db_DropdownWithdrawalReason>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/withdrawal-reasons',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
